var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.61255 16.7666C4.0562 16.7666 0.362549 13.073 0.362549 8.5166C0.362549 3.96025 4.0562 0.266602 8.61255 0.266602C13.1689 0.266602 16.8625 3.96025 16.8625 8.5166C16.8625 13.073 13.1689 16.7666 8.61255 16.7666ZM8.6125 15.2666C12.3404 15.2666 15.3625 12.2446 15.3625 8.51664C15.3625 4.78872 12.3404 1.76664 8.6125 1.76664C4.88458 1.76664 1.8625 4.78872 1.8625 8.51664C1.8625 12.2446 4.88458 15.2666 8.6125 15.2666ZM6.14284 12.0469L8.61251 9.57722L11.0822 12.0469L12.1428 10.9862L9.67317 8.51656L12.1428 6.04689L11.0822 4.98623L8.61251 7.4559L6.14284 4.98623L5.08218 6.04689L7.55185 8.51656L5.08218 10.9862L6.14284 12.0469Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove_icon.f4face7161d363ca17df4256ba38413b.svg";
export { ForwardRef as ReactComponent };